import { render, staticRenderFns } from "./Resize.vue?vue&type=template&id=5ba251b2&"
import script from "./Resize.vue?vue&type=script&lang=js&"
export * from "./Resize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports